import { authHeader, history } from '../_helpers';

export const franchiseService = {
   getFranchises,
   getFranchise,
   getFranchiseByUserId,
   putFranchise,
   postFranchise,
   deleteFranchise
}


function getFranchises() {
   const requestOptions = {
         method: 'GET',
         headers: authHeader()
   };
   return fetch(process.env.REACT_APP_API_URL + '/api/franchises/', requestOptions).then(handleResponse, handleError);
}


function getFranchise(id) {
   const requestOptions = {
         method: 'GET',
         headers: authHeader()
   };
   return fetch(process.env.REACT_APP_API_URL + '/api/franchises/' + id, requestOptions).then(handleResponse, handleError);
}

function getFranchiseByUserId(userId) {
   const requestOptions = {
         method: 'GET',
         headers: authHeader()
   };
   return fetch(process.env.REACT_APP_API_URL + '/api/franchises/byUserId/' + userId, requestOptions).then(handleResponse, handleError);
}

function putFranchise(franchise){
   const requestOptions = {
      method: 'PUT',
      headers: {...authHeader(), 'Content-Type': 'application/json'},
      body: JSON.stringify(franchise)
   };

   return fetch(process.env.REACT_APP_API_URL + '/api/franchises/' + franchise.franchiseId, requestOptions).then(handleResponse, handleError);
}


function postFranchise(franchise){
   const requestOptions = {
      method: 'POST',
      headers: {...authHeader(), 'Content-Type': 'application/json'},
      body: JSON.stringify(franchise)
   };

   return fetch(process.env.REACT_APP_API_URL + '/api/franchises' , requestOptions).then(handleResponse, handleError);
}

function deleteFranchise(id){
   const requestOptions = {
      method: 'DELETE',
      headers: authHeader()
   };
   return fetch(process.env.REACT_APP_API_URL + '/api/franchises/' + id, requestOptions).then(handleResponse, handleError);
}


function handleResponse(response) {
return new Promise((resolve, reject) => {
      if (response.ok) {
         // return json if it was returned in the response
         var contentType = response.headers.get("content-type");
         if (contentType && contentType.includes("application/json")) {
               response.json().then(json => resolve(json));
         } else {
               resolve();
         }
      } else {
         // return error message from response body
         response.text().then(text => reject(text));
         console.log(response);
         if(response.status === 401){
            localStorage.clear();
            history.push('/login');
         }
      }
});
}



function handleError(error) {
   return Promise.reject(error && error.message);
}
